import React, {useState} from 'react';
import {redirect} from "../../utils/commonFunc";
import MainController from "../MainController";
function MainView(props) {
    const [isSearching, setIsSearching] = useState(false);
    const {
        products, searchText, setSearchText,fetchProducts
    } = MainController();
    return (
        <>
            <div className="col row no-gutters" style={{position: 'relative'}}>
                <div className="col">
                    <input className="form-control input-search" autoComplete={"off"} type="search" name="searchtext"
                           placeholder="Tìm kiếm sản phẩm..." defaultValue={searchText}
                           onFocus={() => {
                               setIsSearching(true)
                               fetchProducts()
                           }}
                           onBlur={() => {
                               setIsSearching(false)
                           }}
                           onKeyDown={() => {
                               if (event.key === 'Enter') {
                                   if(searchText && searchText?.trim()!==""){
                                       redirect("",searchText)
                                   } 
                               }
                           }}
                           onChange={(e) => setSearchText(e.target.value)}/>
                </div>
                <div className="col-auto">
                    <button className="btn btn-search text-dark" title="Tìm kiếm" onClick={() => {
                        if(searchText && searchText?.trim()!==""){
                            redirect("",searchText);
                        } 
                    }}>Tìm kiếm
                    </button>
                </div>
                {isSearching && <div className="search-suggestions-desktop">
                    {
                        (products?.length > 0) && (
                            <>
                                <h5 className="search-suggestions-desktop-title">Sản phẩm gợi ý</h5>
                                <div className="search-suggestions-desktop-list">
                                    {products?.map(product => (
                                        <div key={product?.id} style={{cursor: 'pointer'}} onMouseDown={() => {
                                            redirect(product?.name);
                                        }}>
                                            <i className="fa-solid fa-magnifying-glass search-suggestions-icon"></i> {product?.name}
                                        </div>))}
                                </div>
                            </>
                        )
                    }
                </div>}
            </div>
        </>
    )
}

export default MainView;